import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng/errorBoundary';
import styles from './index.css';

class Line extends PureComponent {
    static propTypes = {
        data: PropTypes.array,
        country: PropTypes.string,
    };

    state = {
        type: 0,
    };

    echarts = null;
    line = null;

    async componentDidMount() {
        // 引入 ECharts 主模块
        this.echarts = await import('echarts/lib/echarts');

        // 引入折线图
        await import('echarts/lib/chart/line');
        // 引入提示框和标题组件
        await import('echarts/lib/component/tooltip');
        await import('echarts/lib/component/legend');

        const { type } = this.state;

        this.lineRender(type);
    }

    lineRender = type => {
        const { data, country } = this.props;

        const isAdd = type === 0;

        const list = [...data].reverse();

        this.line = this.echarts.init(document.getElementById('line'));

        // X 轴
        const xData = list.map(item => item.date);

        const text = `${country}疫情${isAdd ? '新增' : '累计'}趋势图`;
        const legendData = isAdd ? ['新增确诊', '新增治愈', '新增死亡'] : ['累计确诊', '累计治愈', '累计死亡'];

        const quezhenList = list.map(item => (isAdd ? item.quezhen_add : item.quezhen));
        const zhiyuList = list.map(item => (isAdd ? item.zhiyu_add : item.zhiyu));
        const siwangList = list.map(item => (isAdd ? item.siwang_add : item.siwang));

        const quezhenItem = {
            name: `${isAdd ? '新增' : '累计'}确诊`,
            type: 'line',
            smooth: true,
            data: quezhenList,
            itemStyle: {
                normal: {
                    color: '#E10000', // 改变折线点的颜色
                    lineStyle: {
                        color: '#E10000', // 改变折线颜色
                    },
                },
            },
        };

        const zhiyuItem = {
            name: `${isAdd ? '新增' : '累计'}治愈`,
            type: 'line',
            smooth: true,
            data: zhiyuList,
            itemStyle: {
                normal: {
                    color: '#28B7A3', // 改变折线点的颜色
                    lineStyle: {
                        color: '#28B7A3', // 改变折线颜色
                    },
                },
            },
        };

        const siwangItem = {
            name: `${isAdd ? '新增' : '累计'}死亡`,
            type: 'line',
            smooth: true,
            data: siwangList,
            itemStyle: {
                normal: {
                    color: '#8C8C8C', // 改变折线点的颜色
                    lineStyle: {
                        color: '#8C8C8C', // 改变折线颜色
                    },
                },
            },
        };

        const seriesList = [quezhenItem, zhiyuItem, siwangItem];

        const option = {
            title: {
                text,
                textStyle: {
                    color: '#212223',
                    fontSize: 14,
                    fontFamily: 'PingFangSC-Medium,PingFang SC',
                    fontWeight: 500,
                },
                top: 12,
                left: -6,
            },
            tooltip: {
                trigger: 'axis',
                padding: 7,
                borderWidth: 1,
                extraCssText: 'background:rgba(0,0,0,0.6);box-shadow: 0px 0px 4px 0px rgba(219,219,219,0.5);',
                textStyle: {
                    color: '#FFFFFF',
                    fontFamily: 'PingFang-SC-Medium,PingFang-SC;',
                    fontSize: 12,
                    padding: 5,
                },
                formatter: params => {
                    let result = `<div>${params[0].name}</div>`;

                    params.forEach(item => {
                        result += `<div style="margin-top: 1px"><span style="display:inline-block;margin: 0 5px 3px 0;border-radius:50%;width:5px;height:5px;font-family: PingFangSC-Regular, PingFang SC;background-color:${
                            item.color
                        }"></span>${item.seriesName}: ${item.value || 0}</div>`;
                    });

                    return result;
                },
            },
            legend: {
                data: legendData,
                icon: 'roundRect',
                top: 14,
                right: 0,
                itemWidth: 8,
                itemHeight: 8,
                textStyle: {
                    color: '#212223',
                    fontSize: 10,
                    fontWeight: 500,
                },
            },
            grid: {
                top: 50,
                left: 0,
                right: 10,
                bottom: 8,
                containLabel: true,
            },
            xAxis: {
                type: 'category',
                boundaryGap: false,
                data: xData,
                axisLine: {
                    lineStyle: {
                        width: 0.5,
                        color: '#e7e9eb',
                    },
                },
                axisTick: {
                    show: false,
                },
                axisLabel: {
                    showMaxLabel: true,
                    color: '#5c5c5c',
                    fontSize: 11,
                },
                axisPointer: {
                    lineStyle: {
                        type: 'dashed',
                        color: '#979797',
                        width: 0.5,
                    },
                },
            },
            yAxis: {
                type: 'value',
                min: 0,
                minInterval: 1,
                axisLine: {
                    lineStyle: {
                        width: 0.5,
                        color: '#e7e9eb',
                    },
                },
                axisTick: {
                    show: false,
                },
                axisLabel: {
                    color: '#5c5c5c',
                    fontSize: 11,
                },
                splitLine: {
                    lineStyle: {
                        width: 0.5,
                    },
                },
            },
            series: seriesList,
        };

        this.line.setOption(option);
    };

    handleTypeChange = type => {
        this.setState(
            {
                type,
            },
            () => {
                this.lineRender(type);
            },
        );
    };

    render() {
        const { type } = this.state;
        const { country } = this.props;

        return (
            <Fragment>
                <div className={styles.line_box}>
                    <div id="line" className={styles.box} />
                </div>
                <div className={styles.btn_box}>
                    <div
                        className={type === 0 ? styles.current_item : styles.item}
                        onClick={() => this.handleTypeChange(0)}>
                        <span>{`${country}新增`}</span>
                    </div>
                    <div
                        className={type === 1 ? styles.current_item : styles.item}
                        onClick={() => this.handleTypeChange(1)}>
                        <span>{`${country}累计`}</span>
                    </div>
                </div>
            </Fragment>
        );
    }
}

export default errorBoundary(Line);
